import { generateRequestActions, createRequestTypes } from 'utils/actionHelpers/actionHelpers'

export const TRADES_LIST = createRequestTypes('TRADES_LIST')

export const getTradesList = generateRequestActions(TRADES_LIST)
